import { db } from 'src/Utils/firebase';

const COLLECTION = 'onboarding';
const TOTAL_STEPS = 7;

/**
 * Get the onboarding progress for a user
 * @param {string} userId - The user ID
 * @returns {Promise<{currentStep: number, completed: boolean}>}
 */
export const getOnboardingProgress = async (userId) => {
    try {
        const doc = await db.collection(COLLECTION).doc(userId).get();
        if (doc.exists) {
            return doc.data();
        }
        return { currentStep: 0, completed: false };
    } catch (error) {
        console.error('Error getting onboarding progress:', error);
        return { currentStep: 0, completed: false };
    }
};

/**
 * Save onboarding progress for a user
 * @param {string} userId - The user ID
 * @param {number} currentStep - The current step (0-indexed)
 * @returns {Promise<void>}
 */
export const saveOnboardingProgress = async (userId, currentStep) => {
    try {
        const completed = currentStep >= TOTAL_STEPS - 1;
        await db.collection(COLLECTION).doc(userId).set({
            currentStep,
            completed,
            lastUpdated: new Date().toISOString(),
            totalSteps: TOTAL_STEPS
        }, { merge: true });
    } catch (error) {
        console.error('Error saving onboarding progress:', error);
    }
};

/**
 * Mark onboarding as completed for a user
 * @param {string} userId - The user ID
 * @returns {Promise<void>}
 */
export const completeOnboarding = async (userId) => {
    try {
        await db.collection(COLLECTION).doc(userId).set({
            currentStep: TOTAL_STEPS - 1,
            completed: true,
            completedAt: new Date().toISOString(),
            lastUpdated: new Date().toISOString(),
            totalSteps: TOTAL_STEPS
        }, { merge: true });
    } catch (error) {
        console.error('Error completing onboarding:', error);
    }
};

export { TOTAL_STEPS };
